module.exports = __webpack_public_path__ + "img/pro-photo12.c57d09e8.jpg";